<template>
  <div class="lightbox-amp" style="position: fixed; top: 0; right: 0; height: 100vh; width: 100%; z-index: 1000;">
    <div>
      <div class="white-bg flex flex-column elevate m3" style="z-index: 1001;border-radius: 5px; max-width: 50vh">
        <!--- min-height-100 min-height-100 :class="containerClasses" --->

        <!-- Modal received data for header area -->
        <div class="p1 white-bg" style="border-radius: inherit;">
          <i
            class="icon icon-cancel h3 right pointer black"
            @click="closeVueRapid()"
          ></i>
        </div>

        <!-- Modal main data area  -->
        <div class="col-12 content p2 pt3">
          <div class="px2">
            <slot name="body"></slot>
          </div>
        </div>
      </div>

      <!-- Modal Closer outside area -->
      <div
        class="top-0 left-0 col-12 absolute modal outside"
        style="z-index: 1000; height: 150vh"
      ></div>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
  components: {},
  setup () {
    const showModal = inject('showModal');

    const closeVueRapid = () => {
      showModal.value = false;
    };

    return { closeVueRapid };
  }
  // mounted() {
  //   var vm = this;
  //   document.onkeydown = function (event) {
  //     if (event.code === "Escape") {
  //       vm.closeVueRapid();
  //     }
  //   };
  // },
};
</script>

<style lang="scss">
 .lightbox-amp > div {
  width: 100%;
  min-height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-box {
    max-width: 800px;
    margin: 0 30px;
  }

  .icon-cancel:hover,
  .icon-cancel:focus {
    color: #e81d00;
    text-decoration: none;
    cursor: pointer;
  }

  .outside{
    background-color: rgba(0,0,0,0.4);
  }
}
</style>
